import React from "react";

import { CourseGroupApi } from "api";
import { PaziaButton } from "components/atoms";
import { SingleCourseGroupFieldForm } from "./SingleCourseGroupFieldForm";
import { CreateCourseGroupFieldModal } from "./CreateCourseGroupFieldModal";

interface CourseGroupPreviewDataFromProps {
  courseGroup: CourseGroupApi;
  fieldType: number;
}
export const CourseGroupPreviewDataFrom = ({ courseGroup, fieldType }: CourseGroupPreviewDataFromProps) => {
  const [expandedId, setExpandedId] = React.useState<number | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const fields = courseGroup?.fields.filter((field) => field.type === fieldType) || [];

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="mb-2 text-xl font-semibold text-slate-800 dark:text-slate-100">
            {fieldType === 1 && "Opis kursu"}
            {fieldType === 2 && "Szczegółowe informacje"}
          </h2>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Zarządzaj polami dla wybranej sekcji ({fields.length}{" "}
            {fields.length === 1 ? "pole" : fields.length < 5 ? "pola" : "pól"})
          </p>
        </div>
        <PaziaButton
          type="primary"
          btnType="button"
          onClick={() => setIsOpen(true)}
          className="w-full shrink-0 sm:w-auto"
        >
          Dodaj nowe pole
        </PaziaButton>
      </div>

      <div className="space-y-4">
        {fields.length > 0 ? (
          fields.map((field) => (
            <SingleCourseGroupFieldForm
              key={field.courseGroupFieldId}
              field={field}
              isExpanded={field.courseGroupFieldId === expandedId}
              courseGroupId={courseGroup.id}
              open={() => setExpandedId(field.courseGroupFieldId)}
              collapse={() => setExpandedId(null)}
            />
          ))
        ) : (
          <div className="rounded-lg border-2 border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center dark:border-slate-600 dark:bg-slate-700/50">
            <svg
              className="mx-auto mb-2 h-8 w-8 text-slate-400 dark:text-slate-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <p className="text-sm text-slate-500 dark:text-slate-400">Nie dodano jeszcze żadnych pól</p>
            <p className="text-xs text-slate-400 dark:text-slate-500">Kliknij "Dodaj nowe pole" aby rozpocząć</p>
          </div>
        )}
      </div>

      <CreateCourseGroupFieldModal
        courseGroupId={courseGroup.id}
        type={fieldType}
        isOpen={isOpen}
        onCloseRequest={() => setIsOpen(false)}
      />
    </div>
  );
};
